import { useEffect, useMemo, useState } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { MotoCard } from "../components/MotoCard";
import { api } from "../lib/api";
import { Bike } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function Motorcycles() {
  const { t } = useLang();
  const [motos, setMotos] = useState([]);
  const [summary, setSummary] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/motorcycles").then((r) => setMotos(r.data)).catch(() => {});
    api.get("/motorcycles/availability").then((r) => setSummary(r.data)).catch(() => {});
  }, []);

  const FILTERS = [
    { key: "all", label: t.motoPage.filters.all },
    { key: "motorcycle", label: t.motoPage.filters.motorcycle },
    { key: "scooter", label: t.motoPage.filters.scooter },
    { key: "atv", label: t.motoPage.filters.atv },
    { key: "available", label: t.motoPage.filters.available },
  ];

  const filtered = useMemo(() => {
    if (filter === "all") return motos;
    if (filter === "available") return motos.filter((m) => m.available);
    return motos.filter((m) => m.category === filter);
  }, [motos, filter]);

  return (
    <div className="App">
      <Navbar />

      <section className="bg-brand-blue text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="inline-flex items-center gap-2 text-brand-sky font-heading font-bold uppercase tracking-[0.2em] text-sm">
            <Bike size={16} /> {t.motoPage.tag}
          </span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl mt-3">{t.motoPage.title}</h1>
          <p className="text-white/80 mt-3 max-w-2xl">{t.motoPage.subtitle}</p>
        </div>
      </section>

      <section className="bg-slate-50 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-wrap gap-3">
          {summary.map((s) => (
            <span key={s.cc} data-testid={`moto-availability-tag-${s.cc}`} className="bg-white border border-slate-200 rounded-full px-4 py-1.5 text-sm font-heading font-semibold text-brand-gray">
              {s.cc}cc · <span className={s.available > 0 ? "text-green-600" : "text-red-500"}>{s.available}/{s.total}</span>
            </span>
          ))}
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-10">
            {FILTERS.map((f) => (
              <button
                key={f.key}
                onClick={() => setFilter(f.key)}
                data-testid={`filter-${f.key}`}
                className={`px-5 py-2 rounded-full font-heading font-bold text-sm transition-colors ${
                  filter === f.key ? "bg-brand-orange text-white" : "bg-slate-100 text-brand-gray hover:bg-slate-200"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
            {filtered.map((m) => <MotoCard key={m.id} moto={m} />)}
          </div>
          {filtered.length === 0 && (
            <p className="text-center text-slate-400 py-16">{t.motoPage.empty}</p>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
